export function hideLegacyPreloader() {
  const el = document.getElementById("preloader");
  if (!el) return;

  el.classList.add("isdone");
  el.style.pointerEvents = "none";

  if (window.jQuery && typeof window.jQuery.fn.fadeOut === "function") {
    window.jQuery(el).stop(true, true).fadeOut(400, () => {
      el.style.display = "none";
      el.style.visibility = "hidden";
    });
    return;
  }

  el.style.display = "none";
  el.style.visibility = "hidden";
}
